// Which dashboard this browser shows: classic (the default) or the new
// experience (v2), which is in beta. People switch to v2 from classic (super
// admins from the sidebar, everyone from Settings › General) and back from
// v2's "Classic dashboard" link. The choice is kept in this browser until it's
// switched again; nothing is saved on the user or the store.
const STORAGE_KEY = 'swell-dashboard-version';

/**
 * True when this browser has switched to the new experience. `?v2=false` on
 * any dashboard URL switches it back to classic, the way out when v2 can't
 * load. It only ever turns v2 off, so the beta warning can't be skipped
 */
export function isV2Enabled() {
  try {
    if (new URLSearchParams(window.location.search).get('v2') === 'false') {
      localStorage.setItem(STORAGE_KEY, 'classic');
    }
    return localStorage.getItem(STORAGE_KEY) === 'v2';
  } catch (err) {
    // Storage unavailable: classic
    return false;
  }
}

/**
 * Switches this browser to 'v2' or 'classic' and reloads the page. Both
 * dashboards use the same URLs, so it opens on the same page.
 */
export function switchDashboard(version) {
  try {
    localStorage.setItem(STORAGE_KEY, version === 'v2' ? 'v2' : 'classic');
  } catch (err) {
    // Storage unavailable: there's no way to keep the choice
    return;
  }
  window.location.reload();
}
